export default {"src":"/_next/static/media/ro.c05f47cb.svg","height":480,"width":640};